module.exports = __webpack_public_path__ + "static/img/mmm-course.708a267.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/personRain/mmm-course.png
// module id = IE2L
// module chunks = 2